import React, { useState, useEffect, useContext, useMemo } from "react";
import { AuthContext } from "../../../contexts/AuthContext";
import Header from "../../../layout/Header/Header";
import {
  Button,
  Row,
  Table,
  Badge,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Input,
  Label,
  ButtonGroup,
  Col,
  Spinner,
  Form,
  FormGroup
} from "reactstrap";
import SweetAlert from "sweetalert2-react";
import Swal from "sweetalert2";
import { jsPDF } from "jspdf";
import "jspdf-autotable";
import autoTable from "jspdf-autotable";
import ExportJsonExcel from "js-export-excel";
import encode from "nodejs-base64-encode";
import axios from "axios";
import moment from 'moment';
import TextField from "@material-ui/core/TextField";
import Autocomplete from "@material-ui/lab/Autocomplete";
import { useTranslation } from "react-i18next";
import i18next from "i18next";

const redondea = (v) => Math.round((Number(v) || 0) * 100) / 100;

// Liquida de lo más viejo a lo más nuevo: la lista ya viene ordenada por fecha
const reparte = (lista, monto) => {
  let resta = redondea(monto);
  return lista.map((f) => {
    const importe = Math.min(resta, Math.max(redondea(f.saldo), 0));
    resta = redondea(resta - importe);
    return { ...f, importe };
  });
};

function AbonosCreate() {
  const { user } = useContext(AuthContext);
  const URL_LOGS = process.env.REACT_APP_URL_LOGS;
  const URL_CLIENTES = process.env.REACT_APP_URL_CLIENTES;
  const URL_ABONOS = process.env.REACT_APP_URL_ABONOS;
  const URL_SURTIDOS = process.env.REACT_APP_URL_SURTIDOS;
  const [t, i18n] = useTranslation("global");
  let date = new Date();
  let hoy = moment(date).format("YYYY-MM-DD");
  
  const [text, setText] = useState(false);
  const [clientes, setClientes] = useState([]);
  const [selectedCliente, setSelectedCliente] = useState("");
  const [selectedClienteNombre, setSelectedClienteNombre] = useState("");
  const [fecha, setFecha] = useState(hoy);


  const [formaPago, setFormaPago] = useState("Transfer");

  const [value, setValue] = useState("");
  const [validaBoton, setValidaBoton] = useState(true);
  const [concepto, setConcepto] = useState("Abono");
  const [importeAplicar, setImporteAplicar] = useState(0);

  const [inputFields, setInputFields] = useState([]);
  const total = redondea(inputFields.reduce((t, c) => t + (Number(c.importe) || 0), 0));
  const saldoAplicar = redondea(redondea(importeAplicar) - total).toFixed(2);

  const [modalProgreso, setModalProgreso] = useState(false);
  const toggleProgreso = () => setModalProgreso(!modalProgreso);



  useMemo(()=>{
    axios
    .get(URL_CLIENTES, {
      headers: {
        Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
      },
    })
    .then((response) => {
      let allClientes = response.data;
      setClientes(allClientes);
    })
    .catch((err) => {
      console.log(err);
    });


    axios
    .get(`${URL_SURTIDOS}/clienteAbono/${selectedCliente}`, {
      headers: {
        Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
      },
    })
    .then((response) => {
      let allSurtidos = response.data
      let arrayTabla = allSurtidos
        .map((a) => {
          return {
            id: a._id,
            fecha: a.fecha,
            total_general: a.montoServicio,
            saldo: a.saldo,
            abonos: a.abonos,
            nota: a.idSurtido,
            importe: 0,
            clientes: a.clientes[0]._id,
            observaciones: "NA",
            movimiento:"Nota",
            idContenedor: a.contenedores[0]._id,
            referencia: a.contenedores[0].referencia,
            numeroReferencia: a.contenedores[0].numeroReferencia,
          };
        }).filter(function (el) {
          return el != null;
        });
        let dataFinal = Object.values(arrayTabla);
        return axios
          .get(`${process.env.REACT_APP_URL_CARGOS_CONTENEDOR}ClientePorPagar/${selectedCliente}`, {
            headers: {
              Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
            },
          })
          .then(({ data }) => {
            const cargos = data.map((a) => ({
              id: a._id,
              tipo: "cargo",
              fecha: a.fecha,
              total_general: a.total,
              saldo: a.saldo,
              abonos: a.abonos,
              nota: a.idCargoContenedor,
              importe: 0,
              clientes: a.clientes[0]._id,
              observaciones: "NA",
              movimiento: `Cargo ${a.tipo === "Liberacion" ? "Liberación" : a.tipo}: ${a.conceptosGastos[0].name}`,
              idContenedor: a.contenedores[0]._id,
              referencia: a.contenedores[0].referencia,
              numeroReferencia: a.contenedores[0].numeroReferencia,
            }));
            const pendientes = [...dataFinal, ...cargos].sort((a, b) => (a.fecha > b.fecha ? 1 : a.fecha < b.fecha ? -1 : 0));
            setInputFields(reparte(pendientes, importeAplicar));
          });
    })
    .catch((err) => {
      console.log(err);
    })


  }, [selectedCliente]);


const handleChangeInputImporte = (id, event) => {
  const { value } = event.target;
  const fila = inputFields.find((i) => i.id === id);
  if (Number(value) < 0) return;
  if (Number(value) > fila.saldo) {
    Swal.fire({
      icon: "error",
      title: "Oops...",
      text: "El Pago excede el Saldo",
    });
    return;
  }
  setInputFields(inputFields.map((i) => (i.id === id ? { ...i, importe: value } : i)));
};



function savePago() {
  if (total > 0 && redondea(importeAplicar) === total) {
    Swal.fire({
      title: "¿Estás seguro?",
      text: "Se registrará el abono",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Sí, enviar!",
    }).then((result) => {
      if (result.isConfirmed) {
        toggleProgreso();
        let totalMails = inputFields.length;

        inputFields.map((a) => {
          if (a.importe > 0) {
            axios
              .post(
                URL_ABONOS,
                {
                  fecha,
                  importe: Number(a.importe),
                  clientes: selectedCliente,
                  ...(a.tipo === "cargo" ? { cargosContenedor: a.id } : { surtidos: a.id }),
                  formaPago,
                  concepto,
                  observaciones: a.observaciones,
                  contenedores: a.idContenedor,
                },
                {
                  headers: {
                    Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
                  },
                }
              )
              .then(() => {
                totalMails--;
                if (totalMails == 0) {
                  Swal.fire("¡Éxito!", "Creado con éxito", "success");
                  setTimeout(() => {
                    window.location.reload();
                  }, 1000);
                }
              })
              .catch((error) => {
                Swal.fire({
                  icon: "error",
                  title: "Oops...",
                  text: "Algo salió mal",
                });
                console.log(error);
              });
          } else {
            totalMails--;
          }
        });
      }
    });
  } else {
    Swal.fire({
      icon: "error",
      title: "Oops...",
      text: "Todavía te queda saldo por aplicar",
    });
  }
}


const handleChangeInput = (id, event) => {
  const newInputFields = inputFields.map((i) => {
    if (id === i.id) {
      i[event.target.name] = event.target.value;
    }
    return i;
  });
  setInputFields(newInputFields);
};


const options = clientes.map((option) => {
    const junta = option.nombre_comercial;
    const firstLetter = option.nombre_comercial[0].toUpperCase();
    return {
      firstLetter: /[0-9]/.test(firstLetter) ? "0-9" : firstLetter,
      ...option,
      junta,
    };
  });

  // Cada cambio del importe vuelve a repartir; después se puede ajustar renglón por renglón
  function IA(e) {
    setImporteAplicar(e);
    setInputFields(reparte(inputFields, e));
  }

// function clear(){
//   setInputFields([])
//   setValue("")
//   setSelectedCliente("")
//   setSelectedClienteNombre("")
//   setFormaPago("Efectivo")
//   setConcepto("Abono")
// }

  return (
    <>
      <Header />
      {user.abonosCreate  ?(
        <div className="card container col-sm-11">
          <div className="page-header">
            <div>
              <h3 className="page-title">
                <span className="page-title-icon"><i className="fas fa-hand-holding-usd" /></span>
                {t("Captura un Abono")}
              </h3>
              <p className="page-subtitle">{t("Registra un pago del cliente y aplícalo a sus notas")}</p>
            </div>
          </div>
          <Form>
            <FormGroup className="mb-2 mr-sm-2 mb-sm-0">
              <div className="form-section">
                <div className="form-section-header"><i className="fas fa-info-circle" /><h4 className="form-section-title">{t("Datos del abono")}</h4></div>
                <div className="form-section-body">
              <Row>
              <Col md={2}>
                  <Label>{t("Fecha")}</Label>
                  <Input
                    type="date"
                    value={fecha}
                    required
                    onChange={(e) => {
                      setFecha(e.target.value);
                    }}
                  />
                </Col>
                <Col md={3}>
                <Label className="mr-sm-2">{t("Cliente")}</Label>
                <Autocomplete
                    size="small"
                    value={value}
                    onChange={(event, selectedCliente) => {
                      setValue(selectedCliente)
                      // Al borrar el buscador llega null
                      setSelectedCliente(selectedCliente ? selectedCliente._id : "")
                      setSelectedClienteNombre(selectedCliente ? selectedCliente.nombre_comercial : "")
                      if (!selectedCliente) setInputFields([])
                    }}
                    options={options.sort(
                      (a, b) => -b.firstLetter.localeCompare(a.firstLetter)
                    )}
                    groupBy={(option) => option.firstLetter}
                    getOptionLabel={(option) => option.junta}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        label="Selecciona"
                        variant="outlined"
                      />
                    )}
                    renderOption={(option) => (
                      <React.Fragment>
                        {option.codigo} {option.nombre_comercial}
                      </React.Fragment>
                    )}
                  />
                </Col>
                <Col md={2}>
                    <Label className="mr-sm-2">{t("Concepto")}</Label>
                    <Input
                      type="select"
                      value={concepto}
                      onChange={(e) => {
                        setConcepto(e.target.value);
                      }}
                    >
                      <option value="">{t("Selecciona un Concepto")}</option>
                      <option value="Abono">{t("Pago")}</option>
                      <option value="Bonificacion">{t("Bonificacion")}</option>
                    </Input>
                  </Col>

                <Col md={2}>
                    <Label className="mr-sm-2">{t("Forma de Pago")}</Label>
                    <Input
                      type="select"
                      value={formaPago}
                      onChange={(e) => {
                        setFormaPago(e.target.value);
                      }}
                    >
                      <option value="">{t("Selecciona una Forma de Pago")}</option>
                      <option value="Efectivo">{t("Efectivo")}</option>
                      <option value="Transfer">{t("Transfer")}</option>
                      <option value="TDC">TDC</option>
                      <option value="Bonificacion">{t("Bonificacion")}</option>
                    </Input>
                  </Col>
                
               
            
                <Col md={3}>
                <h4 align="right">
                              {t("Total Pago")}{"  "}
                              <Badge id="Total" color="danger" className="BadgeSize badge-pill">
                                {"$" + new Intl.NumberFormat("en-US").format(total)}
                              </Badge>
                            </h4>
                </Col>
              </Row>
                </div>
              </div>

              <div className="form-section">
                <div className="form-section-header"><i className="fas fa-coins" /><h4 className="form-section-title">{t("Importe a aplicar")}</h4></div>
                <div className="form-section-body">
              <Row>
             <Col md={2}>
  <Label>Importe Por Aplicar</Label>
  <Input
    type="number"
    step="0.01"
    value={importeAplicar}
    onChange={(e) => IA(e.target.value)}
    className="form-control"
  />
</Col>

<Col md={2}>
  <Label>Saldo Por Aplicar</Label>
  <Input
    type="number"
    step="0.01"
    value={saldoAplicar}
    className="form-control"
    disabled
  />
</Col>
              </Row>
                </div>
              </div>

              <div className="form-section">
                <div className="form-section-header"><i className="fas fa-file-invoice-dollar" /><h4 className="form-section-title">{t("Notas pendientes")}</h4></div>
                <div className="form-section-body">
             <Row>
                {/* Tabla Surtidos */}
              <Table size="sm" hover className="table-responsive-xl">
                <thead>
                  <tr>
                  <th>{t("Fecha")}</th>
                  <th>{t("Movimiento")}</th>
                  <th>{t("Referencia")}</th>
                  <th>{t("Contenedor")}</th>
                  <th className="td-num">{t("Total")}</th>
                  <th className="td-num">{t("Pagos")}</th>
                  <th className="td-num">{t("Saldo")}</th>
                  <th>{t("Importe")}</th>
                  <th>{t("Observaciones")}</th>
                  </tr>
                </thead>
                <tbody>
                  {inputFields.map((a) => (
                      // <div key={a.id}>
                            <tr>
                            <td>{a.fecha}</td>
                            <td>{a.movimiento}</td>
                            <td className="td-strong">{a.referencia}</td>
                            <td className="td-strong">{a.numeroReferencia}</td>
                            <td className="td-num td-money">{"$" + new Intl.NumberFormat("en-US").format(a.total_general)}</td>
                            <td className="td-num td-money">{"$" + new Intl.NumberFormat("en-US").format(a.abonos)}</td>
                            <td className="td-num td-money">{"$" + new Intl.NumberFormat("en-US").format(a.saldo)}</td>
                            <td>
                              <Input
                              bsSize="sm"
                                type="number" 
                                min="0"
                                step="0.01"
                                name="importe"
                                value={a.importe}
                                key={a.id}
                                onChange ={(e)=>{handleChangeInputImporte(a.id, e)
                                }}/>
                            </td>
                            <td>
                              <Input
                              bsSize="sm"
                                type="text" 
                                name="observaciones"
                                value={a.observaciones}
                                key={a.id}
                                onChange ={(e)=>{handleChangeInput(a.id, e)
                                }}/>
                            </td>
                            </tr>
                          // </div>
                  ))}

                </tbody>
                <br />
              </Table>
          

            {/* Termina tabla surtidos */}

             </Row>
                </div>
              </div>
            </FormGroup>
            <div className="submit-bar">
            <Button
              color="success"
              onClick={savePago}
            >
              <i className="fas fa-save" /> {t("Guardar")}
            </Button>

              <Button
                href="/ListadoAbonos"
                color="secondary"
                id="botonListado"
              >
                <i className="fas fa-arrow-left" /> {t("Regresar")}
              </Button>
            </div>
          </Form>
          <Modal size="sm" isOpen={modalProgreso} toggle={toggleProgreso}>
                  <ModalHeader toggle={toggleProgreso}>
                    <h4>{t("Progreso")}</h4>
                  </ModalHeader>
                  <ModalBody>
                    Estamos enviando los correos, este proceso puede tardar
                    varios minutos.
                    <br />
                    {t("Por favor no cierre ni refresque su navegador.")}
                    <br />
                    <div className="divPadre2">
                      <div className="divHijo2">
                        <Spinner
                          style={{
                            width: "3rem",
                            height: "3rem",
                            color: "#232B41",
                          }}
                        />
                        <Spinner
                          style={{
                            width: "3rem",
                            height: "3rem",
                            color: "#232B41",
                          }}
                        />
                        <Spinner
                          style={{
                            width: "3rem",
                            height: "3rem",
                            color: "#232B41",
                          }}
                        />
                      </div>
                    </div>
                  </ModalBody>
                </Modal>

               
        </div>
      ): undefined } 
      
    </>
  );
}

export default AbonosCreate;
